import { BaseProps } from '@/components/types'
import { ChangeEvent, FocusEvent, useState, useEffect } from 'react'
import '@/assets/scss/control/table-input.scss'
import { TableInputWrapper } from '../types/table'

function TableTextBox ( props: TableTextBoxProps ) {
    const {
        value = '', width, height = '100%', style,
        textAlign = 'left', unitText,
        onChange,
        ...rest
    } = props
    const [ input, setInput ] = useState( value )

    useEffect( () => {
        setInput( value || '' )
    }, [ value ] )

    const onFocus = ( e: FocusEvent<HTMLInputElement> ) => {
        e?.target.select()
    }
    const onCustomChange = ( e: ChangeEvent<HTMLInputElement> ) => {
        const { target } = e || {}
        const { value: targetValue } = target

        setInput( targetValue )
        onChange && onChange( targetValue )
    }
    return (
        <div className="table-input-wrapper">
            <div className="table-input-container flex">
                <input
                    { ...rest }
                    className="table-text-box"
                    value={ input }
                    style={ { textAlign, ...style, width, height, } }
                    onChange={ onCustomChange }
                    onFocus={ onFocus }
                />
                { unitText && <div className="table-text-unit">{ unitText }</div> }
            </div>
        </div>
    )
}

export default TableTextBox

export interface TableTextBoxProps extends BaseProps, TableInputWrapper<string> {}